(function () {
  "use strict";

  const I18N = {
    en: {
      toggleLabel: "EN | ES",
      crumbHome: "Home",
      // override header breadcrumb so it is not "Peru Shipping"
      crumbAbout: "About Us",

      aboutUs: "About Us",
      subtitle:
        "FHL GO is the simple way to ship from the USA to your home. From documents to cherished gifts, we simplify the cross-border maze so you can focus on people—not paperwork.",
      ctaShip: "Ship with FHL GO",
      ctaWhy: "Why FHL GO",
      quickWho: "Who We Are",
      quickWhy: "Why We’re Different",
      quickPromise: "Our Promise",
      whoTitle: "Who We Are",
      whoBody1:
        "We’re a cross-border shipping service built for real life. Families, students, entrepreneurs—anyone who needs a package to move reliably from the U.S. to Latin America. Our team blends tech that keeps you in the loop with hands-on logistics that keep your package moving.",
      whoBody2:
        "From first scan to final hand-off, you’ll see where your shipment is, what it costs, and when it will arrive. No mystery fees, no vanishing numbers—just clear steps and human support when you need it.",
      whoBody3:
        "Today we support lanes to Peru, Venezuela, and Costa Rica through trusted partners—and we’re expanding smartly, adding routes only when we can maintain our service standard.",
      whyTitle: "Why We’re Different",
      why1:
        "<b>Speed &amp; Reliability:</b> We prioritize carriers with clean handoffs and consistent scans, so your delivery timeline is a plan—not a guess.",
      why2:
        "<b>Transparent by Default:</b> Clear quotes before you ship, visible steps along the way, and simple explanations of what you’re paying for.",
      why3:
        "<b>Built for People:</b> Support that can actually fix things. Use self-service when it’s faster; talk to a person when it matters.",
      why4:
        "<b>Designed for Growth:</b> Whether you ship once a year or every week, our tools grow with you—labels, saved addresses, and shipment history in one place.",
      promiseTitle: "Our Promise",
      promiseBody1:
        "Your package isn’t just cargo—it’s a story on the move. We’ll treat it with the care we’d want for our own families, from pickup to delivery.",
      promiseBody2:
        "We don’t hide fees or disappear when something gets complicated. If there’s a change or delay, you’ll hear it from us with options—not excuses.",
      promiseLi1:
        "Transparent pricing and accurate delivery estimates before you pay",
      promiseLi2: "Door-to-door options in most metro areas",
      promiseLi3:
        "Real humans when you need help, automation when you don’t",
      readyTitle: "Ready to ship?",
      readyNote:
        "Get an instant quote and choose the speed that fits your timeline and budget. Stay informed at every step with clear updates.",
      readyCta: "Get a Quote",
      followTitle: "FOLLOW US ON",
      companyTitle: "COMPANY",
      legalTitle: "LEGAL INFO",
      lnkAbout: "About Us",
      lnkServices: "Services",
      lnkBlog: "Blog",
      lnkTerms: "Terms of Service",
      lnkPrivacy: "Privacy Policy",
      lnkRefunds: "Refund Policy",
      copyright:
        "© 2025 FHL GO. Powered by Shopify — Developed by DIGIFUZEFX",

      countryPickerTitle: "Where are you shipping?",
      countryPickerBody: "Choose your destination to get shipping options and pricing.",
      countryPeru: "Ship to Peru",
      countryVenezuela: "Ship to Venezuela",
      countryCostaRica: "Ship to Costa Rica",

    },

    es: {
      toggleLabel: "ES | EN",
      crumbHome: "Inicio",
      // same key, Spanish label for About
      crumbAbout: "Quiénes Somos",

      aboutUs: "Quiénes Somos",
      subtitle:
        "FHL GO es la forma simple de enviar desde EE. UU. a tu casa. Desde documentos hasta regalos especiales, simplificamos el laberinto transfronterizo para que te enfoques en las personas, no en el papeleo.",
      ctaShip: "Enviar con FHL GO",
      ctaWhy: "Por qué FHL GO",
      quickWho: "Quiénes Somos",
      quickWhy: "Por qué Somos Diferentes",
      quickPromise: "Nuestra Promesa",
      whoTitle: "Quiénes Somos",
      whoBody1:
        "Somos un servicio de envíos transfronterizos diseñado para la vida real. Familias, estudiantes, emprendedores—cualquiera que necesite mover paquetes de EE. UU. a Latinoamérica con fiabilidad. Combinamos tecnología para mantenerte informado con logística práctica que mantiene tu envío en movimiento.",
      whoBody2:
        "Desde el primer escaneo hasta la entrega final, verás dónde está tu envío, cuánto cuesta y cuándo llegará. Sin cargos sorpresa ni información que desaparece—solo pasos claros y soporte humano cuando lo necesites.",
      whoBody3:
        "Hoy operamos rutas hacia Perú, Venezuela y Costa Rica con aliados confiables, y seguimos expandiendo de forma responsable, agregando rutas solo cuando podemos mantener nuestro estándar de servicio.",
      whyTitle: "Por qué Somos Diferentes",
      why1:
        "<b>Velocidad y Fiabilidad:</b> Priorizamos carriers con relevos limpios y escaneos consistentes, para que tu tiempo de entrega sea un plan y no una apuesta.",
      why2:
        "<b>Transparencia por Defecto:</b> Cotizaciones claras antes de enviar, pasos visibles en el proceso y explicaciones simples de lo que estás pagando.",
      why3:
        "<b>Hecho para las Personas:</b> Soporte que realmente resuelve. Usa el autoservicio cuando es más rápido; habla con alguien cuando importa.",
      why4:
        "<b>Diseñado para Crecer:</b> Ya envíes una vez al año o todas las semanas, nuestras herramientas crecen contigo—etiquetas, direcciones guardadas e historial de envíos en un solo lugar.",
      promiseTitle: "Nuestra Promesa",
      promiseBody1:
        "Tu paquete no es solo carga—es una historia en movimiento. Lo trataremos con el mismo cuidado que queremos para nuestras familias, desde la recolección hasta la entrega.",
      promiseBody2:
        "No escondemos costos ni desaparecemos cuando algo se complica. Si hay un cambio o retraso, te lo contamos con opciones—no con excusas.",
      promiseLi1:
        "Precio transparente y tiempos de entrega estimados antes de pagar",
      promiseLi2:
        "Opciones puerta a puerta en la mayoría de áreas urbanas",
      promiseLi3:
        "Personas reales cuando necesitas ayuda; automatización cuando no",
      readyTitle: "¿Listo para enviar?",
      readyNote:
        "Obtén una cotización al instante y elige la velocidad que se ajuste a tu tiempo y presupuesto. Mantente informado en cada etapa con comunicaciones claras.",
      readyCta: "Obtener Cotización",
      followTitle: "SÍGUENOS",
      companyTitle: "COMPAÑÍA",
      legalTitle: "INFO LEGAL",
      lnkAbout: "Quiénes somos",
      lnkServices: "Servicios",
      lnkBlog: "Blog",
      lnkTerms: "Términos del servicio",
      lnkPrivacy: "Política de privacidad",
      lnkRefunds: "Política de reembolsos",
      copyright:
        "© 2025 FHL GO. Con tecnología de Shopify — Desarrollado por DIGIFUZEFX",

      countryPickerTitle: "¿A dónde envías?",
      countryPickerBody: "Elige tu destino para ver opciones de envío y precios.",
      countryPeru: "Enviar a Perú",
      countryVenezuela: "Enviar a Venezuela",
      countryCostaRica: "Enviar a Costa Rica",

    },
  };

  function applyLang(lang) {
    const dict = I18N[lang] || I18N.en;

    document.querySelectorAll("[data-i18n]").forEach((el) => {
      const key = el.dataset.i18n;
      if (dict[key]) el.textContent = dict[key];
    });

    document.querySelectorAll("[data-i18n-html]").forEach((el) => {
      const key = el.dataset.i18nHtml;
      if (dict[key]) el.innerHTML = dict[key];
    });

    // Update pill label if header has data-i18n="toggleLabel"
    document.querySelectorAll('[data-i18n="toggleLabel"]').forEach((el) => {
      el.textContent = dict.toggleLabel || el.textContent;
    });

    document.title =
      lang === "es" ? "FHL GO — Quiénes Somos" : "FHL GO — About Us";

    try {
      localStorage.setItem("fhl_lang", lang);
    } catch (e) {}

    // Let the logo/header listener know
    try {
      const evt = new CustomEvent("fhlgo:lang-switch", { detail: { lang } });
      document.dispatchEvent(evt);
    } catch (e) {}
  }

  function getSavedLang() {
    try {
      return localStorage.getItem("fhl_lang") || "en";
    } catch (e) {
      return "en";
    }
  }

  function initLanguage() {
    // Apply saved language on load
    applyLang(getSavedLang());

    // Delegate click on the lang pill: anything with data-i18n="toggleLabel"
    document.addEventListener("click", function (evt) {
      const toggle = evt.target.closest('[data-i18n="toggleLabel"]');
      if (!toggle) return;

      const current = getSavedLang();
      const next = current === "en" ? "es" : "en";
      applyLang(next);
    });

    // Also respond if some other script fires a lang-switch event
    document.addEventListener("fhlgo:lang-switch", function (e) {
      if (!e.detail || !e.detail.lang) return;
      applyLang(e.detail.lang);
    });
  }

  function initRevealOnScroll() {
    const prefersReduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const targets = document.querySelectorAll(".about-page [data-reveal]");
    if (!targets.length) return;

    if (prefersReduced) {
      targets.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    targets.forEach((el) => io.observe(el));
  }

  document.addEventListener("DOMContentLoaded", function () {
    initLanguage();
    initRevealOnScroll();
  });
})();
